import { render, staticRenderFns } from "./simpleSlider.vue?vue&type=template&id=43b1e00c"
import script from "./simpleSlider.vue?vue&type=script&lang=js"
export * from "./simpleSlider.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports